const SEP = '[\\s/_.-]';
const YEAR = '(20\\d{2}|\\d{2})';

/**
 * SCAR index formats by county. Each key is canonical so 809452/2025, SCAR_809452_25 and 809452-2025 compare equal.
 * Prefixed formats come first so ER_60018_2026 is not also read as 60018/2026. Mirrors SCAR_INDEX_FORMATS in PythonReqs/src/AVTN/FeatureMap.py.
 */
const SCAR_INDEX_FORMATS = [
  { re: `er${SEP}*(\\d{5})${SEP}+${YEAR}`, key: (n, y) => `ER${n}/20${y.slice(-2)}` }, // Putnam ER60018/2026
  { re: `ef${SEP}*(\\d{6})${SEP}+${YEAR}`, key: (n, y) => `EF${n}-20${y.slice(-2)}` }, // Orange EF500060-2026
  { re: `(efsc|esc)${SEP}*(20\\d{2})${SEP}+(\\d{1,5})`, key: (p, y, n) => `${p.toUpperCase()}${y}-${Number(n)}` }, // Greene, Delaware, Ulster EFSC2026-99; Sullivan ESC2026-99
  { re: `er${SEP}*(\\d{8})`, key: (n) => `ER${n}` }, // Nassau ER25732492
  { re: `e01${SEP}*(20\\d{2})${SEP}*(\\d{6})`, key: (y, n) => `E01${y}${n}` }, // Columbia E012026026135
  { re: `(20\\d{2})${SEP}+(\\d{5})`, key: (y, n) => `${y}-${n}` }, // Dutchess 2026-54474
  { re: `(\\d{5,6})${SEP}+${YEAR}`, key: (n, y) => `${n}/20${y.slice(-2)}` }, // Suffolk 800516/2026, Westchester 90013/2026, Rockland 073370/2026
].map((f) => ({
  ...f,
  exact: new RegExp(`^\\s*${f.re}\\s*$`, 'i'),
  anywhere: new RegExp(`(?:^|[^a-z0-9])${f.re}(?![a-z0-9])`, 'gi'),
}));

/** Canonical key when the whole value is a SCAR index in any county format, else null. */
export const scarIndexKey = (value) => {
  for (const f of SCAR_INDEX_FORMATS) {
    const m = String(value ?? '').match(f.exact);
    if (m) return f.key(...m.slice(1));
  }
  return null;
};

/** Canonical keys of every SCAR index appearing anywhere in text, e.g. a filename. */
export const findScarIndexKeys = (text) => {
  const keys = new Set();
  SCAR_INDEX_FORMATS.reduce((rest, f) => rest.replace(f.anywhere, (...m) => keys.add(f.key(...m.slice(1))) && ' '), String(text ?? ''));
  return keys;
};
